import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const addStlife = async (title, token) => {
    let postdata = {
        title: title,
        slug: title.replace(" ", "-")
    }
  return await axios.post(`${API_BASE_URL}/stlife/add`, postdata, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const getStlife = async (data, token) => {
    return await axios.post(`${API_BASE_URL}/stlife/get`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
};

export const uploadStlife = async (formData, token) => {
    return await axios.post(`${API_BASE_URL}/stlife/upload-images`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
};

export const getStlifeImages = async (id, token) => {
    return await axios.get(`${API_BASE_URL}/stlife/get-images/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
};

export const updateStLifeStatus = async (id, active, token) => {
  return await axios.put(`${API_BASE_URL}/stlife/update-status/${id}`, {active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const updateStatusStLifeImage= async (id, row, token) => {
  return await axios.put(`${API_BASE_URL}/stlife/update-image-status/${id}`, {name: row.name, active: !row.active}, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};